export const getters = {
  invoiceproductRows: state => state.invoice_products,
  systemInvoices: state => state.invoices
};
export default getters;



// WEBPACK FOOTER //
// ./src/vuex/modules/invoices/getters.js